/* Svensk katalog for locale-supplier-country-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  "purchaseDocs.removeAll": "Ta bort alla",
  "purchaseDocs.removeOne": "Ta bort {name} från inköpet",
  "purchaseDocs.duplicateTitle": "Möjlig dubbelbokföring",
  "purchaseDocs.duplicateHelp": "Kontrollera tidigare inköp innan du bokför. Du kan ändå bokföra.",
  "purchaseDocs.sameAttachment": "Samma fil har bifogats flera gånger.",
  "purchaseDocs.sameFile": "Samma fil används på verifikation {number} · {date}.",
  "purchaseDocs.sameDetails": "Verifikation {number} · {date} har samma datum och belopp.",
  "purchaseFlow.listTitle": "Inköpslista",
  "purchaseFlow.purchaseCount": "Inköp",
  "purchaseFlow.netPurchases": "Nettoinköp",
  "purchaseFlow.netPurchasesHelp": "Exkl. moms, efter kreditnotor",
  "purchaseFlow.includingVat": "Inkl. moms",
  "purchaseFlow.credited": "Krediterat",
  "purchaseFlow.creditable": "Kvar att kreditera",
  "purchaseFlow.creditAllocationHelp": "Välj fakturan före bokföring för automatisk avräkning. Belopp över det obetalda saldot blir ett tillgodohavande hos leverantören.",
  "err.supplierCredit.invalidAmount": "Kreditbeloppet måste vara positivt och får inte överstiga det belopp som inte redan krediterats. Betalningar minskar inte gränsen.",
  "err.purchase.duplicateSupplierDocument": "Dokumentnumret är redan registrerat för leverantören. Öppna den befintliga fakturan eller kreditnotan.",
  'purchaseFlow.creditNote': 'Kreditnota',
  "purchaseFlow.negativeWarning": "Ett negativt fakturabelopp är ovanligt om det inte är en kreditnota.",
  "purchaseFlow.creditOriginal": "Faktura som krediteras (valfritt)",
  "purchaseFlow.standaloneCredit": "Ingen koppling – tillgodo hos leverantören",
  "purchaseFlow.creditLinesRequired": "Använd nya negativa rader och bokför kreditnotan direkt. Utkast och redigering stöds inte här.",
  "err.supplierCredit.unsupportedLines": "Använd vanliga inköpsrader. Lager, tillgångar och särskild moms kräver en separat rättelse.",
  'registry.toggleSupplierHelp': 'Föreslår norska företag medan du skriver leverantörsnamn eller organisationsnummer.',
  'sup.foreignToggle': 'Utländsk leverantör',
  'sup.foreignToggleHelp': 'Slå på för leverantörer som är registrerade i ett annat land än ditt företag.',
  'sup.countryCode': 'Landskod',
  'sup.countryCodePh': 'T.ex. SE eller US',
  'sup.countryRequired': 'Ange en landskod med två bokstäver för den utländska leverantören.',
  'sup.registrationNumber': 'Registreringsnummer',
  'sup.registrationNumberPh': 'Leverantörens utländska registreringsnummer',
  'sup.vatNumber': 'VAT-/momsnummer',
  'sup.vatNumberPh': 'T.ex. SE123456789001',
});
